module.exports = __webpack_public_path__ + "static/media/vivo.c28cb330.png";